//
// Main Nav functions
//

const MOBILENAV_MENU_WRAP_ID = 'mobile-menu-wrap';
const MOBILENAV_TRIGGER_CLASS = '.js-mobile-menu-visibility-trigger';

const MOBILENAV_SUBNAV_CLASS = '.js-mobile-menu__level-2';
const MOBILENAV_SUBNAV_TRIGGER_CLASS = '.js-mobile-subnav-trigger';

const MOBILENAV_CTRL_SEARCH_TRIGGER_CLASS = '.js-mobile-menu-ctrl__search-trigger';
const MOBILENAV_SEARCH_INPUT_ID = 'js-mobile-search-input';

export default class MobileNav {
    constructor() {

        // Mobile nav elements
        this.mobileNav = document.getElementById(MOBILENAV_MENU_WRAP_ID);
        this.mobileNavTriggers = document.querySelectorAll(MOBILENAV_TRIGGER_CLASS);

        if (!this.mobileNav) return;

        // Mobile nav search
        this.mobileNavSearchTriggers = document.querySelectorAll(MOBILENAV_CTRL_SEARCH_TRIGGER_CLASS);
        this.mobileNavSearchInput = document.getElementById(MOBILENAV_SEARCH_INPUT_ID);

        // Mobile subnav
        this.mobileNavSubNavTriggers = document.querySelectorAll(MOBILENAV_SUBNAV_TRIGGER_CLASS);
        this.mobileNavSubNavs = document.querySelectorAll(MOBILENAV_SUBNAV_CLASS);

      this.init();
    }

    init() {
      this.addEventHandling();
    }

    /**
     * @public
     */
    toggleMobileNav(event) {
        event.preventDefault();

        if(this.mobileNav.classList.contains('mobile-menu-wrap--open')) {
            this.mobileNav.classList.remove('mobile-menu-wrap--open');
            document.body.classList.remove('body-mobile-menu-open');
            // Hide the search too
            this.mobileNav.classList.remove('mobile-menu-wrap--search-open');
        } else {
            this.mobileNav.classList.add('mobile-menu-wrap--open');
            // Add class to the body element
            document.body.classList.add('body-mobile-menu-open');
        }

    }

    toggleMobileNavSearch(event) {
        event.preventDefault();

        if(this.mobileNav.classList.contains('mobile-menu-wrap--search-open')) {
            this.mobileNav.classList.remove('mobile-menu-wrap--search-open');
        } else {
            this.mobileNav.classList.add('mobile-menu-wrap--search-open');
            // Toggle focus to search area
            this.mobileNavSearchInput.focus();
        }
    }

    toggleMobileSubNav(event) {
        let currentMobileSubNav = event.currentTarget;
        let targetMobileSubNav = currentMobileSubNav.getAttribute('aria-controls');

        // Remove active class from all buttons, and add to clicked one
        this.mobileNavSubNavTriggers.forEach(mobileSubNavTrigger => {
            if (mobileSubNavTrigger != currentMobileSubNav) {
                mobileSubNavTrigger.classList.remove('mobile-menu__top-link--active');
                mobileSubNavTrigger.setAttribute('aria-expanded', 'false');
            } else {
                mobileSubNavTrigger.classList.toggle('mobile-menu__top-link--active');
                mobileSubNavTrigger.getAttribute('aria-expanded') == 'false' ? mobileSubNavTrigger.setAttribute('aria-expanded', "true") : mobileSubNavTrigger.setAttribute('aria-expanded', "false");
            }
        });

        // Hide all SubNav Elemns and show clicked one
        this.mobileNavSubNavs.forEach(mobileSubNav => {
            // Get SubNav ID
            let currentMobileSubNav = mobileSubNav.id;

            // If current nav matches target button, then show
            if (currentMobileSubNav === targetMobileSubNav) {
                mobileSubNav.classList.toggle('mobile-menu__level-2--open');
            } else {
                mobileSubNav.classList.remove('mobile-menu__level-2--open');
            }
        });
    }

    /**
     * @public
     */
    addEventHandling() {
        // Open/Close Mobile nav
        this.mobileNavTriggers.forEach(mobileNavTrigger => {
            mobileNavTrigger.addEventListener('click', this.toggleMobileNav.bind(this));
        });

        // Show/Hide Mobile nav search area
        this.mobileNavSearchTriggers.forEach(mobileNavSearchTrigger => {
            mobileNavSearchTrigger.addEventListener('click', this.toggleMobileNavSearch.bind(this));
        });

        // Expand/Collapse Mobile nav areas
        this.mobileNavSubNavTriggers.forEach(mobileNavSubNavTrigger => {
            mobileNavSubNavTrigger.addEventListener('click', this.toggleMobileSubNav.bind(this));
        });
    }
  }